import { connect } from "react-redux";
import {
	Card as MuiCard,
	CardContent,
	Typography as MuiTypography,
	Box,
	Avatar,
	Tooltip,
	AvatarGroup,
} from "@mui/material";
import { styled } from "@mui/styles";
import { spacing } from "@mui/system";
import useBusinessDivisions from "../../hooks/queries/useBusinessDivisions";
import { avatarGroupStyles } from "../../theme/avatars";
import { makeStyles } from "@mui/styles";

const Card = styled(MuiCard)(spacing);
const Typography = styled(MuiTypography)(spacing);

const useStyles = makeStyles((theme) => ({
	card: {
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(3),
	},
}));

const DivisionCards = ({ accountId, users }) => {

	const { data: divisions } = useBusinessDivisions(accountId);
	const avatarClasses = avatarGroupStyles();
	const classes = useStyles();

	const divisionName = d => {
		let name = d.divisionName;

		if (d.accountName)
			name += ` (${d.accountName})`

		return name;
	};

	const avatar = (userId) => {
		let user = users[userId];

		return (
			<Tooltip key={userId} title={<span style={{ whiteSpace: 'pre-line' }}>{user?.name || "--"}<br />{user?.position || "--"}</span>} >
				<Avatar src={user?.photo} alt={user?.name || "--"} />
			</Tooltip>
		);		
	}

	const avatarGroup = m => {		

		return (
			<Box display="flex" flexDirection="column" alignItems="center" key={m.role} mb={6} ml={6} mr={6}>
				<AvatarGroup max={10} className={avatarClasses.large}>
					{m.userIds.map(id => avatar(id))}
				</AvatarGroup>				
				<Typography variant="subtitle2">{m.role}</Typography>
				<Typography variant="caption">{m.name}</Typography>
			</Box>
		);
	}

	if (!divisions || divisions.length === 0)
		return null;

	return (
		<>
            {
				divisions.map(d => (
					<Card key={d.id} className={classes.card}>
						<CardContent>
							<Typography variant="h6" mb={6}>{divisionName(d)}</Typography>
							<Box display="flex">
								<Box display="flex" flexDirection="column" gap="10px">
									<Box>
										<Typography variant="subtitle2">Risk Level</Typography>
										<Typography variant="caption">{d.risk || "Not set"}</Typography>
									</Box>
									<Box>
										<Typography variant="subtitle2">Key Account</Typography>
										<Typography variant="caption">{d.keyAccount ? "Yes" : "No"}</Typography>
									</Box>
								</Box>
								<Box display="flex" justifyContent="space-around" flexWrap="wrap">
									{d.members.map(m => avatarGroup(m))}
								</Box>
							</Box>
						</CardContent>
					</Card>
				))}
        </>
    );
}

const mapStateToProps = (state) => ({ users: state.userReducer.users });

export default connect(mapStateToProps)(DivisionCards);